module.exports = __webpack_public_path__ + "31f3e6e32efaea42704bcd43a567a887.svg";